import { Card } from '@material-ui/core';
import { ProductImages } from 'components/ui-components';
import { OptionsObject, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from 'store';

import noimage from '../../static/noimage.png';
import { successSnackbar } from '../../utils/snackbar.utils';
import { AddToCart } from './AddToCart/AddToCart';
import useStyles from './product-details.css';

interface MatchParams {
    articulo: string;
}

function ProductDetailsComponent(props: any) {
    console.log(props);
    const store: any = useSelector((state: RootState) => state.cart);
    const styles = useStyles();
    const [image, setImage] = useState('');
    const [dataProduct, setDataProduct] = useState({
        articulo: '',
        img: noimage,
        Nombre: 'Nombre Articulo',
        Descripcion: 'description',
        precio: [{ PrecioIVA: 0 }],
    });

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [_dataProduct, setProduct]: any = useState({});

    const [imgSrc, setImgSrc] = useState('');
    const [qty, setQty] = useState(0);

    useEffect(() => {
        setProduct({
            articulo: `${dataProduct.articulo}`,
            img: image,
            name: dataProduct.Nombre,
            description: dataProduct.Descripcion,
            price: dataProduct.precio[0] && dataProduct.precio[0].PrecioIVA | 0,
        });
    }, [image, dataProduct]);

    useEffect(() => {
        console.log(_dataProduct);
    }, [_dataProduct]);

    function handleAddProduct(qty: number) {
        console.log(qty);
        if (
            store.cart.findIndex(
                (x: { articulo: string }) => x.articulo === dataProduct.articulo
            ) === -1
        ) {
            dispatch({
                type: 'ADDPRODUCTQUANTITY',
                payload: { product: _dataProduct, qty: qty },
            });
        } else {
            console.log('El producto no esta en el carrito');
            dispatch({
                type: 'ADDQUANTITYNUMBER',
                payload: { product: _dataProduct, qty: qty },
            });
        }

        enqueueSnackbar(
            'Producto añadido al carrrito',
            successSnackbar as OptionsObject
        );
    }

    return (
        <>
            <div className={styles.root}>
                <div className={styles.container}>
                    <ProductImages
                        articulo={props.info.params.articulo}
                        onImage={setImage}
                    />
                    <AddToCart
                        articulo={props.info.params.articulo}
                        setDataProduct={setDataProduct}
                        addProduct={handleAddProduct}
                    />
                </div>
                <Card className={styles.description}>
                    <h2>
                        {_dataProduct.description}
                    </h2>
                </Card>
            </div>
        </>
    );
}

export default ProductDetailsComponent;
